import { initializeServiceRequest } from 'owa-service/lib/config';
import getIndexedPath from 'owa-url/lib/getIndexedPath';

export function bootstrapServiceRequest(path: string) {
    // Always make a request to user's backend.
    let baseUrl = getIndexedPath('/owa', path);
    initializeServiceRequest({
        baseUrl: baseUrl,
    });
}
